import React from 'react';

import t from '../../../labels/labelling-utils';
import { IComponent } from '../../../typings/generic-component';
import { makeClassNames } from '../../../utils/styles';

import './error.scss';

export interface IError extends IComponent {}

const defaultError = t('unavailable.data');

const classNames = () =>
  makeClassNames({
    error: 'error',
  });

const Error = ({ children = defaultError }: IError) => {
  const cn = classNames();

  return <div className={cn.error}>{children}</div>;
};

export default Error;
